export const watchNavbarCollapse = () => {
	if (document.getElementById('main-nav')) {
		const navbar = document.getElementById('main-nav');
		const navbarCollapse = document.getElementById('navbar-collapse');
		navbarCollapse.addEventListener(
			'show.bs.collapse',
			() => (navbar.dataset.drawerExpanded = true)
		);
		navbarCollapse.addEventListener(
			'hide.bs.collapse',
			() => (navbar.dataset.drawerExpanded = false)
		);
	}
};
